// extracted by mini-css-extract-plugin
export var avatarContainer = "_4v-1";
export var largeAvatarContainer = "_4v-2";
export var smallAvatarContainer = "_4v-0";